import { render, staticRenderFns } from "./DeliveryFee.vue?vue&type=template&id=0aadc643&scoped=true"
import script from "./DeliveryFee.vue?vue&type=script&lang=js"
export * from "./DeliveryFee.vue?vue&type=script&lang=js"
import style0 from "./DeliveryFee.vue?vue&type=style&index=0&id=0aadc643&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aadc643",
  null
  
)

export default component.exports